module.exports = __webpack_public_path__ + "img/lucasfalsarellaguerreiro_formal.b2891f62.jpg";